import formSubmitStyle from "@/src/components/Form/Common/FormSubmit/formSubmitStyle";

const summaryStyle = {
  subHeadline: {
    marginTop: "2rem",
    paddingBottom: "0.625rem",
    borderBottom: "1px solid",
    borderColor: "divider",
    "& h6": {
      color: "text.primary",
    },
  },
  question: {
    marginTop: "1rem",
    fontWeight: 400,
  },
  ...formSubmitStyle,
  questionsTextArea: {
    margin: "2rem 0",
  },
};

export default summaryStyle;
